/* eslint-disable max-len */
import { SvgProps } from './types'

/**
 * Ícone de preenchimento, diferente dos de contorno desta pasta: a cor vai
 * em fill, não em stroke.
 *
 * O viewBox foi apertado na tinta do arquivo original (noun_people_8283001.svg),
 * que vinha com folga grande em volta do desenho — sem isso o ícone
 * apareceria bem menor que os vizinhos na mesma fileira.
 */
export const PeopleGroupIcon = ({ color, className }: SvgProps) => (
  <svg
    width="99.6"
    height="51.6"
    viewBox="4.9 34 99.6 51.6"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <path d="M91.9,59.9c2.5-1.9,4.1-4.9,4.1-8.3,0-5.7-4.6-10.3-10.3-10.3s-10.3,4.6-10.3,10.3,1.6,6.4,4.1,8.2c-2.5.8-4.8,2.2-6.7,3.9-2.8-3.7-6.6-6.6-11.1-8,3.1-2.1,5.2-5.7,5.2-9.8,0-6.5-5.3-11.9-11.9-11.9s-11.9,5.3-11.9,11.9,2.1,7.7,5.2,9.8c-4.5,1.4-8.4,4.3-11.1,8-2-1.8-4.3-3.1-6.7-3.9,2.5-1.9,4.1-4.9,4.1-8.2,0-5.7-4.6-10.3-10.3-10.3s-10.3,4.6-10.3,10.3,1.6,6.4,4.1,8.3c-7.7,2.6-13.2,9.8-13.2,18.2v4.1c0,.9.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-4.1c0-8.9,7.3-16.2,16.2-16.2s8.2,1.7,11.2,4.5c-1.7,3.1-2.6,6.7-2.6,10.5v7.2c0,.9.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-7.2c0-3.4.9-6.7,2.5-9.5,0,0,0,0,0,0,.3-.2.4-.5.5-.8,3.4-5.3,9.3-8.8,16-8.8s12.6,3.5,16,8.8c0,.3.2.6.5.8,0,0,0,0,0,0,1.6,2.8,2.5,6,2.5,9.5v7.2c0,.9.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-7.2c0-3.8-1-7.3-2.6-10.5,3-2.9,7-4.5,11.2-4.5,8.9,0,16.2,7.3,16.2,16.2v4.1c0,.9.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-4.1c0-8.5-5.5-15.7-13.1-18.2h0ZM17,51.7c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2-7.2-3.2-7.2-7.2ZM46.2,46.1c0-4.8,3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8-3.9,8.8-8.8,8.8-8.8-3.9-8.8-8.8ZM78.5,51.7c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2-7.2-3.2-7.2-7.2Z" fill={color} />
    </g>
  </svg>
)
